export const SCREEN_FRAME_WIDTH = 64;
export const SCREEN_FRAME_HEIGHT = 64;
export const RGB565_BYTES_PER_PIXEL = 2;
export const RGB565_FRAME_BYTES = SCREEN_FRAME_WIDTH * SCREEN_FRAME_HEIGHT * RGB565_BYTES_PER_PIXEL;
